export default __webpack_public_path__ + "static/media/68.d9dc2ce9.jpeg";